<div class="table-layout">
  <ion-row>
    <ion-col size="4">
      <p class="formLabelBoldfs18">Preview</p>
    </ion-col>
    <ion-col size="8" class="text-right">
      <img [mat-dialog-close] class="" src="././assets/icon/close_icon.png">
    </ion-col>
  </ion-row>
  <ion-header class="header-style">
    <ion-row>
      <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="p-0 d-flex">
        <img src="././assets/icon/phiedgeSidebarpoweredbyIcon.jpg" class="logoHeight ">
        <img src="././assets/icon/SidebarShow.svg" class="sideBarHambergarHeight isShowDesktopView">
      </ion-col>
      <ion-col size-sm="9" size-md="9" size-lg="9" size-xs="9" class="p-0">
        <div class="d-flex pr-10 pb-5 float-right">
          <label class="mt-10 settingCircle display-center">
            <i class="material-icons ">settings</i>
          </label>
          <label class="profile-circle display-center">
            <ion-label class="fs-14 fs_12ForMobile font-medium">FL</ion-label>
          </label>
          <div class="d-flex isShowDesktopView">
            <div class="flex-column mt-10">
              <ion-label class="fs-12 font_semibold  black_color">First Last</ion-label>
              <ion-label class="fs-12 font_semibold  text_red mt-10">Super Admin</ion-label>
            </div>
            <img src="././assets/icon/arrow_down_black.png" class="pl-10 pr-20 mt-25 h-10 ">
          </div>
          <!--         
          <div>
            <img src="././assets/icon/arrow_down_black.png" class="">
          </div> -->
        </div>
      </ion-col>
    </ion-row>
  </ion-header>

  <ion-row>
    <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="p-0">
      <div class="sidenav isShowDesktopView">
        <div class="overflow">
          <div class="clear10"></div>
          <div>
            <a id="blue" class="active" [style.background-color]="moduleNameColor">
              <img src="././assets/icon/HomeIconBlack.svg" class="sidebaricon">
              <span class="fs-14 fs_12ForMobile font_medium">PMS</span>
            </a>
          </div>
          <div>
            <a id="blue" class="listview">
              <img src="././assets/icon/HomeIconBlack.svg" class="sidebaricon">
              <span class="fs-14 fs_12ForMobile font_medium">ELCM</span>
            </a>
          </div>
          <div>
            <a id="blue" class="listview">
              <img src="././assets/icon/HomeIconBlack.svg" class="sidebaricon">
              <span class="fs-14 fs_12ForMobile font_medium">Task Management</span>
            </a>
          </div>
          <div class="clear40"></div>
        </div>
      </div>
    </ion-col>
    <ion-col size-sm="12" size-md="9" size-lg="9" size-xs="12" class="p-0">
      <div class="tabs-container">
        <div class="tabs font_regular">
          <div class="tab activeTab fs-14 fs_12ForMobile" [style.background-color]="subModuleButtonColor">
            <span class="material-icons">speed</span>Dashboard
          </div>
          <div class="tab fs-14 fs_12ForMobile inactive">
            <span class="material-icons">ads_click</span>My Goals
          </div>
        </div>
      </div>
      <ion-row>
        <ion-col size-sm="6" size-md="2" size-lg="2" size-xs="6">
          <ion-label class="formLabelRegularfs14">From</ion-label>
        </ion-col>
        <ion-col size-sm="6" size-md="2" size-lg="2" size-xs="6">
          <ion-label class="formLabelRegularfs14">To</ion-label>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col size-sm="12" size-md="4" size-lg="4" size-xs="12" class="p-0">
          <ion-row class="p-0">
            <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6">
              <input type="month" id="start" name="start" class="inputBox outlineNone" [(ngModel)]="currentDate" />
            </ion-col>
            <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6">
              <input type="month" id="start" name="start" class="inputBox outlineNone" [(ngModel)]="currentDate" />
            </ion-col>
          </ion-row>
        </ion-col>
        <ion-col size-sm="12" size-md="12" size-lg="8" size-xs="12" class="text-right">
          <div class="d-flex float-right">
            <button type="button" class="pms_btn center-content fs-14 fs_12ForMobile ml-5"><span class="displayContent">
                <span class="material-icons fs-20 mr-5">calendar_today</span>
                Previous Months KPI</span></button>
            <button type="button" class="pms_btn center-content fs-14 fs_12ForMobile ml-5"><span class="displayContent">
                <span class="material-icons fs-20 mr-5">person</span>
                Reporting Manager KPI</span></button>
          </div>

        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col size-sm="12" size-md="8" size-lg="8" size-xs="12">
          <div class="d-flex">
            <ng-select placeholder="Select Employee" class="w-30">
              <ng-option></ng-option>
            </ng-select>
            <ion-label class="center-content ml-10 fs-14 fs_12ForMobile font_medium pr-10 black_color">Show</ion-label>
            <mat-form-field class="w-10 mat-height40 mat-input-style">
              <mat-select placeholder="Select" placeholder="Select">
              </mat-select>
            </mat-form-field>
          </div>
        </ion-col>
        <ion-col size-sm="12" size-md="12" size-lg="4" size-xs="12" class="text-right display-end">
          <ul class="dt_pagination">
            <ion-row class="float-right pgintn">
              <li class="active fs-16 fs_14ForMobile font_regular">1</li>
              <span class="fs-14 fs_12ForMobile font_regular p-10">of 1</span>
              <li class="fs-24 fs_18ForMobile">&lt;</li>
              <li class="fs-24 fs_18ForMobile">&gt;</li>
            </ion-row>
          </ul>
        </ion-col>
      </ion-row>
      <div class="tableCardBox mb-15">
        <ion-row>
          <ion-col size-sm="12" size-md="12" size-lg="4" size-xs="12">
            <mat-form-field class="mat-height40 mat-input-style">
              <mat-icon matPrefix>search</mat-icon>
              <input matInput type="search" placeholder="Search">
            </mat-form-field>
          </ion-col>
          <ion-col size-sm="12" size-md="12" size-lg="8" size-xs="12">
            <div class="d-flex float-right d-blockForMobile t-rightFormobile">
              <div class="mr-10">
                <div class="font_regular fs-12">Some Columns are hidden-</div>
                <div class="font_regular fs-12 text-right"><u class="" [style.color]="buttonColorName">click here to show all</u></div>
              </div>
          <div class="verticle-center mt-10ForMobile">
            <button type="button" class="add_btn fs-14 fs_12ForMobile mr-10" [style.background-color]="buttonColorName">
              + New KPI</button>
            <button class="materialBtnIcon black_color fs-14 fs_12ForMobile font_semibold mr-15">
              <span class="material-icons">download</span></button>
            <button [style.background-color]="buttonColorName" class="customMaterialIcon fs-14 fs_12ForMobile">
              <span class="material-icons">tune</span></button>
          </div>
            </div>
          </ion-col>
        </ion-row>
        <div class="table-container mt-5">
          <table class="hover">
            <thead>
              <tr>
                <th class="fs-14 fs_12ForMobile font_regular cl-black" *ngFor="let item of tableHeadData">
                  <div class="verticle-center icon-style">{{item}}
                    <span class="material-icons  ml-5 mt-3 fs-14 fs_12ForMobile">visibility_off</span>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody class="bg-white">
              <tr *ngFor="let item of tableData">
                <td class="fs-14 fs_12ForMobile font_regular">{{item.review}}</td>
                <td class="fs-14 fs_12ForMobile font_regular">{{item.kra}}</td>
                <td class="fs-14 fs_12ForMobile font_regular">{{item.kpi}}</td>
                <td class="fs-14 fs_12ForMobile font_regular">{{item.lesserisbetter}}</td>
                <td class="fs-14 fs_12ForMobile font_regular">{{item.milestoneFrom}}</td>
                <td class="fs-14 fs_12ForMobile font_regular">{{item.milestoneTo}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </ion-col>
  </ion-row>
</div>